// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N9EC","colBig":"styles_colBig__hjT_9","colSmall":"styles_colSmall__1UfO7","shopifyNameWrapper":"styles_shopifyNameWrapper__1Rt3h"};